import { Platform } from "react-native";

/**
 * Identifies web environments known to cause issues with authentication flows
 * that rely on popup windows (`window.open()`).
 *
 * These "problematic" environments, specifically the Facebook in-app browser
 * and the Apple Mail client, often block or improperly handle popups. This
 * can prevent users from completing OAuth logins or other multi-window
 * authentication processes. This function helps in detecting these clients
 * to provide fallback authentication methods or user guidance.
 *
 * @returns {boolean} Returns `true` if a problematic browser is detected,
 *                    otherwise `false`.
 */

export function isProblematicBrowser() {
  if (Platform.OS !== "web") {
    return false;
  }

  const ua = navigator.userAgent.toLowerCase();

  const isFacebookBrowser =
    ua.includes("fbav") || ua.includes("fbios") || ua.includes("fban");

  // Must be iOS device, user agent must include AppleWebKit,
  // but not include "Version/" (which indicates Safari) or "CriOS/" (which indicates Chrome) or "FxiOS/" (which indicates Firefox)
  const isAppleMailClient =
    /iphone|ipad|ipod|macintosh/.test(ua) &&
    ua.includes("applewebkit") &&
    !ua.includes("version/") &&
    !ua.includes("crios/") &&
    !ua.includes("fxios/") &&
    !ua.includes("chrome/") &&
    !ua.includes("safari/") &&
    !ua.includes("firefox/") &&
    !ua.includes("edgios/") &&
    !ua.includes("edg/") &&
    !ua.includes("opr/") &&
    !ua.includes("opera/") &&
    !ua.includes("brave/") &&
    !ua.includes("vivaldi/") &&
    !ua.includes("yabrowser/") &&
    !ua.includes("oculusbrowser/") &&
    !ua.includes("gsa/");

  const isSnapchatBrowser = ua.includes("snapchat");

  return isFacebookBrowser || isAppleMailClient || isSnapchatBrowser;
}
